import { render, staticRenderFns } from "./ListaItensCarrinho.vue?vue&type=template&id=0076a552&scoped=true&"
import script from "./ListaItensCarrinho.vue?vue&type=script&lang=js&"
export * from "./ListaItensCarrinho.vue?vue&type=script&lang=js&"
import style0 from "./ListaItensCarrinho.vue?vue&type=style&index=0&id=0076a552&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0076a552",
  null
  
)

export default component.exports